export default __webpack_public_path__ + "static/media/select-inquiry-golden.83b3a33a.svg";